module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLight.529e267.woff2";